var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-loading"},[_c('img',{staticClass:"mb-5",attrs:{"src":"assets/logo/logo-polpum.svg","alt":"","width":"201px","height":"87px"}}),(_vm.status == '')?_c('b-spinner',{attrs:{"large":""}}):_vm._e(),(_vm.status == 'error')?_c('span',[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }